<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">受注内容確認書の承認</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<div class="my-1">
					<p>※承認を押すと受注内容確認書が承認となり、登録者にメッセージが送信されます。</p>
					<p>※却下を押すと、理由を入力するフォームが開きます。</p>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="12">
						<v-row class="ma-0 pa-0" justify="space-around">
							<v-btn class="ma-1" @click="$emit('approve')" color="primary"> 承認する</v-btn>
							<v-btn class="ma-1 white--text" @click="reasonDialog = true" color="red">
								却下する</v-btn
							>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
		<ReasonDialog
			v-if="reasonDialog"
			:reason.sync="reason"
			@close="reasonDialog = false"
			@reject="$emit('reject', reason)"
		/>
	</v-dialog>
</template>

<script>
import ReasonDialog from "../components/ReasonDialog.vue"

export default {
	components: {
		ReasonDialog,
	},
	data() {
		return {
			dialog: true,
			reason: null,
			reasonDialog: false,
		}
	},
}
</script>
